module.exports = "https://cdn.thelire.com/ins/resource/order@3x.d204057b99c390d04e29a0f94b0e82c5.png";